import { type FC } from 'react';
import { type UserRole } from '@shared/services';
import { Radio } from '@selfinspectionorg/ui-kit';
import styles from './LoginAccount.module.scss';
import { normalizeUserRole } from '@/shared/utils';

interface Props {
  userId: number;
  companyName: string;
  role: UserRole;
  isSelected: boolean;
  showRadio: boolean;
  onChange: () => void;
}

export const LoginAccount: FC<Props> = ({ userId, companyName, role, isSelected, showRadio, onChange }) => {
  const content = (
    <>
      <div className={styles.accountText}>
        <div className={styles.companyName}>{companyName}</div>
        <div className={styles.role}>{normalizeUserRole(role)}</div>
      </div>
      {showRadio && (
        <Radio
          id={`LoginAccountRadio${userId}`}
          name="login-account-selection"
          checked={isSelected}
          onChange={onChange}
          size="small"
        />
      )}
    </>
  );

  if (!showRadio) {
    return <div className={styles.accountHeader}>{content}</div>;
  }

  return (
    <label className={styles.accountItem} htmlFor={`LoginAccountRadio${userId}`}>
      {content}
    </label>
  );
};
